/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Preview_Next_TitleInputs */

const en_image_export_preview_next_title = /** @type {(inputs: Image_Export_Preview_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next event`)
};

const fr_image_export_preview_next_title = /** @type {(inputs: Image_Export_Preview_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenement suivant`)
};

const de_image_export_preview_next_title = /** @type {(inputs: Image_Export_Preview_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächste Veranstaltung`)
};

const it_image_export_preview_next_title = /** @type {(inputs: Image_Export_Preview_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prossimo evento`)
};

const ru_image_export_preview_next_title = /** @type {(inputs: Image_Export_Preview_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следующее событие`)
};

const es_image_export_preview_next_title = /** @type {(inputs: Image_Export_Preview_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo evento`)
};

const zh_cn2_image_export_preview_next_title = /** @type {(inputs: Image_Export_Preview_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一个活动`)
};

const ja_image_export_preview_next_title = /** @type {(inputs: Image_Export_Preview_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のイベント`)
};

const hi_image_export_preview_next_title = /** @type {(inputs: Image_Export_Preview_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगली घटना`)
};

const pt_pt2_image_export_preview_next_title = /** @type {(inputs: Image_Export_Preview_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo evento`)
};

/**
* | output |
* | --- |
* | "Next event" |
*
* @param {Image_Export_Preview_Next_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_preview_next_title = /** @type {((inputs?: Image_Export_Preview_Next_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Preview_Next_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_preview_next_title(inputs)
	if (locale === "de") return de_image_export_preview_next_title(inputs)
	if (locale === "it") return it_image_export_preview_next_title(inputs)
	if (locale === "ru") return ru_image_export_preview_next_title(inputs)
	if (locale === "es") return es_image_export_preview_next_title(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_preview_next_title(inputs)
	if (locale === "ja") return ja_image_export_preview_next_title(inputs)
	if (locale === "hi") return hi_image_export_preview_next_title(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_preview_next_title(inputs)
	return en_image_export_preview_next_title(inputs)
});